import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { reaction } from "mobx";

import { ICommand } from "Application";
import { Box, Button, EditDate, EditSelect, Label } from "Components";
import { CloseIcon } from "Styles/ThemedPrimitives/Style1/CloseIcon";
import { MentorAbsenceViewModel } from "./MentorAbsenceViewModel";
import { WeeklyRotaDetailsViewModel } from "../WeeklyRotaDetailViewModel";
import { Container, Footer, ButtonGroup, StyledDialog, Header, FormField, TwoCol } from "./MentorAbsenceView.styles";

export interface IProps {
    cancelCommand: ICommand;
    viewModel: WeeklyRotaDetailsViewModel;
}

const MentorAbsenceView: React.FC<IProps> = observer((props: IProps) => {
    const [absenceViewModel] = useState(() => new MentorAbsenceViewModel());

    // Load mentors once on mount
    useEffect(() => {
        absenceViewModel.initialize();
    }, []);

    // Close the modal when the form is submitted successfully
    useEffect(() => {
        return reaction(
            () => absenceViewModel.submittedSuccessfully,
            (success) => {
                if (success) props.cancelCommand.execute();
            },
        );
    }, []);

    const saveCommand = absenceViewModel.addMentorAbsenceCommand(props.viewModel);

    return (
        <>
            <StyledDialog open={true}>
                <Header>
                    Add mentor absence <CloseIcon onClick={props.cancelCommand.execute} />
                </Header>
                <Container>
                    <Box>
                        <FormField>
                            <EditSelect
                                displayName="Select Mentor"
                                placeholder="Type name of mentor or select from dropdown"
                                command={absenceViewModel.updateMentorSelectTimeCommand}
                                options={absenceViewModel.mentorOptions}
                                validationMessage={() => absenceViewModel.getError("mentorId")}
                                value={() => absenceViewModel.getValue("mentorId")}
                            />
                        </FormField>
                        <TwoCol display={"grid"} style={{ gap: "30px" }} mt="26px">
                            <Box>
                                <Label mb={"5px"} fontStyle="label">
                                    Starting
                                </Label>
                                <FormField mb={"20px"}>
                                    <EditDate
                                        displayName={""}
                                        value={() => absenceViewModel.getValue("absenceStartDate")}
                                        command={absenceViewModel.updateMentorAbsenceStartDateCommand}
                                        mode="date"
                                        disableWeekends={true}
                                        currentDate={props.viewModel.startDateForAbsenceRange}
                                    />
                                </FormField>
                                <FormField>
                                    <EditSelect
                                        displayName={"Please select"}
                                        command={absenceViewModel.updateMentorAbsenceShiftCommand}
                                        options={absenceViewModel.getAbsenceShift}
                                        value={() => absenceViewModel.getValue("absenceShift")}
                                        validationMessage={() => absenceViewModel.getError("absenceShift")}
                                    />
                                </FormField>
                            </Box>
                            <Box>
                                <Label mb={"5px"} fontStyle="label">
                                    Ending
                                </Label>
                                <FormField mb={"20px"}>
                                    <EditDate
                                        displayName={""}
                                        value={() => absenceViewModel.getValue("absenceEndDate")}
                                        command={absenceViewModel.updateMentorAbsenceEndDateCommand}
                                        mode="date"
                                        currentDate={props.viewModel.startDateForAbsenceRange}
                                    />
                                </FormField>
                                <FormField>
                                    <EditSelect
                                        displayName={"Please select"}
                                        command={absenceViewModel.updateMentorAbsenceTimeCommand}
                                        options={absenceViewModel.filteredMentorAbsenceTime}
                                        value={() => absenceViewModel.getValue("absenceTime")}
                                        validationMessage={() => absenceViewModel.getError("absenceTime")}
                                    />
                                </FormField>
                            </Box>
                        </TwoCol>
                    </Box>
                    <Footer>
                        <ButtonGroup>
                            <Button command={saveCommand} displayName={"ADD"} paletteColor="primary" />
                            <Button displayName={"CANCEL"} paletteColor="secondary" command={props.cancelCommand} />
                        </ButtonGroup>
                    </Footer>
                </Container>
            </StyledDialog>
        </>
    );
});

export default MentorAbsenceView;
